/**
 *
 * @author Matthew Rawson @ 22/01/2019 16:05
 * @description
 * @notes
 */
import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"


class SurveyResponseRenderer extends PureComponent {
  static propTypes = {
    original: PropTypes.shape({
      questionStats: PropTypes.object,
      sendCount: PropTypes.number,
      responseCount: PropTypes.number
    }).isRequired
  }


  render() {
    const idNamespace = id("SurveyResponseRenderer", this.props)
    const {original: {questionStats, responseCount, sendCount}} = this.props
    const responses = questionStats ? `${responseCount} / ${sendCount}` : "--"

    return <span id={id("responses", idNamespace)}>{responses}</span>
  }
}

export default SurveyResponseRenderer
